import {
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import styled from '@emotion/styled';
import {
  leftDrawerDimen,
  mainAppBarDimen,
  rightDrawerDimen,
  toolBarDimen,
  toPixel,
} from '../styles/dimensions';
import { useMainFrameDispatch, useMainFrameState } from '../MainFrame';
import { useEffect } from 'react';
import { isUndefined } from 'lodash';
import {
  ACTION_CLOSE_NOTIFICATION_DRAWER,
  ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
  ACTION_RIGHT_DRAWER,
  ACTION_RIGHT_DRAWER_JSX,
} from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { clearNotificationById } from '../../../redux/features/notificationSlice';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

const toolBarMixin = isToolbarOpen => {
  return {
    ...(isToolbarOpen && {
      marginTop: toPixel(toolBarDimen.height + mainAppBarDimen.height),
      height: `calc(100vh - ${toPixel(
        toolBarDimen.height + mainAppBarDimen.height
      )})`,
    }),
    ...(!isToolbarOpen && {
      marginTop: toPixel(mainAppBarDimen.height),
      height: `calc(100vh - ${toPixel(mainAppBarDimen.height)})`,
    }),
  };
};

const openMixin = (theme, isToolbarOpen) => {
  return {
    width: -toPixel(leftDrawerDimen.open.width),
    '& .MuiDrawer-paper': {
      width: toPixel(rightDrawerDimen.open.width),
      backgroundColor: theme.palette.rightFloatingDrawerColor,
      ...toolBarMixin(isToolbarOpen),
    },
  };
};

const closeMixin = (theme, isToolbarOpen) => {
  return {
    width: -toPixel(leftDrawerDimen.closed.width),
    '& .MuiDrawer-paper': {
      // width: toPixel(rightDrawerDimen.closed.width),
      width: toPixel(0),
      backgroundColor: theme.palette.rightFloatingDrawerColor,
      ...toolBarMixin(isToolbarOpen),
    },
  };
};

const NVDrawerRight = styled(Drawer, {
  shouldForwardProp: props => true,
})(({ theme, open, isToolbarOpen }) => {
  return {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && openMixin(theme, isToolbarOpen)),
    ...(!open && closeMixin(theme, isToolbarOpen)),
  };
});

const DefaultNotificationJsx = props => {
  const dispatch = useMainFrameDispatch();
  const notificationList = useSelector(
    state => state?.notification?.notificationList
  );
  const reduxDispatch = useDispatch();
  dayjs.extend(relativeTime);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: 1,
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <Icon>notifications</Icon>
            <Typography>Notification</Typography>
          </Box>
          <Box>
            <IconButton
              onClick={() =>
                dispatch({ type: ACTION_CLOSE_NOTIFICATION_DRAWER })
              }
            >
              <Icon>close</Icon>
            </IconButton>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <List>
          {notificationList?.map(item => {
            return (
              <>
                <ListItem
                  secondaryAction={
                    <IconButton
                      onClick={() => {
                        reduxDispatch(clearNotificationById({ id: item?.id }));
                      }}
                      edge="end"
                      aria-label="comments"
                    >
                      <Icon>close</Icon>
                    </IconButton>
                  }
                >
                  <ListItemText
                    key={item?.id}
                    primary={item?.title}
                    secondary={
                      <>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          color="text.secondary"
                        >
                          {item?.descriptions}
                        </Typography>
                        <br />
                        <Typography
                          sx={{
                            fontSize: 11,
                          }}
                          variant="caption"
                        >
                          {dayjs(item?.id).fromNow()}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
                <Divider />
              </>
            );
          })}
        </List>
      </Grid>
    </Grid>
  );
};

const NVNotificationDrawer = props => {
  const dispatch = useDispatch();
  const { isNotificationDrawerOpen, isToolbarOpen } = useMainFrameState();

  // useEffect(() => {
  //     window.addEventListener('click', function (e) {
  //         if (!document.getElementById('NVDrawerRight').contains(e.target)) {
  //             dispatch({ type: ACTION_CLOSE_NOTIFICATION_DRAWER })
  //         }
  //     });
  // }, [isNotificationDrawerOpen])

  return (
    <>
      <NVDrawerRight
        variant="permanent"
        anchor="right"
        open={isNotificationDrawerOpen}
        isToolbarOpen={isToolbarOpen}
        id="NVDrawerRight"
      >
        <Box
          sx={{
            marginBottom: toPixel(mainAppBarDimen.height),
          }}
        >
          <DefaultNotificationJsx />
        </Box>
      </NVDrawerRight>
    </>
  );
};

export default NVNotificationDrawer;
